import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/app.states';
import { UsersService } from 'src/app/features/users/services/users.service';
import { UsersActions } from 'src/app/features/users/state/users.action-types';
import { AuditLogService } from 'src/app/features/invoices/services/audit-log.service';

@Component({
  selector: 'app-connect-fapro-modal',
  templateUrl: './connect-fapro-modal.component.html',
  styleUrls: ['./connect-fapro-modal.component.scss'],
})
export class ConnectFaproModalComponent {
  representationTermsAccepted = false;
  solKeyTermsAccepted = false;

  faproUrl = 'https://finsmartpe.fapro.app/';

  representationTermsLabel =
    'Declaro que poseo las facultades de representación para efectuar actos de disposición sobre el RUC de la empresa, en nombre e interés de ella';
  solKeyTermsLabel =
    'Declaro que he leído, comprendido y acepto los <a href="https://storage.googleapis.com/finsmart-websitefiles/legal/declaracion-entrega-credenciales-2026-07-22.pdf" target="_blank" rel="noopener noreferrer" class="fapro-link">términos de uso</a> de mi Clave SOL.';

  constructor(
    private store: Store<AppState>,
    private usersService: UsersService,
    private auditLogService: AuditLogService,
    public dialogRef: MatDialogRef<ConnectFaproModalComponent>
  ) {}

  get canContinue(): boolean {
    return this.representationTermsAccepted && this.solKeyTermsAccepted;
  }

  continue() {
    if (!this.canContinue) {
      return;
    }

    this.usersService.markFaproRegistered().subscribe({
      next: () => {
        this.store.dispatch(UsersActions.LoadProfile());
        this.dialogRef.close(true);
        window.open(this.faproUrl, '_blank', 'noopener,noreferrer');
      },
      error: () => {
        this.dialogRef.close(false);
      },
    });
  }

  cancel() {
    this.auditLogService.create('cancel').subscribe();
    this.dialogRef.close(false);
  }
}
